<script>
import {mapGetters} from 'vuex'
export default
{
    name: 'mv-timetable-form',

    computed:
    {
        ...mapGetters({
            routes: 'routes',
        }),
    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },

        addFile(file)
        {
            this.model.attachments.push(file)
        },

        removeFile(file)
        {
            for (let i = 0; i < this.model.attachments.length; ++i)
            {
                const item = this.model.attachments[i]
                if (file.id == item.id)
                {
                    this.model.attachments.splice(i, 1)
                }
            }

        },

    },

    props:
    {
        model: Object,
        edit: Boolean,
    },

    created()
    {
        this.$store.dispatch('trackerRoutesFetch')
    },

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">
        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.ROUTE') }}
            </label>
            <div class="col-md-6">
                <select class="form-control" v-model="model.bus_route_id">
                    <option v-for="route in routes" :key="route.id" :value="route.id">
                        {{ route.name }}
                    </option>
                </select>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('GENERAL.START') }}
            </label>
            <div class="col-md-6">
                <mv-date-time-picker v-model="model.start" only-time></mv-date-time-picker>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('GENERAL.RETURN') }}
            </label>
            <div class="col-md-6">
                <input type="checkbox" v-model="model.is_return">
            </div>
        </div>


    </form>
</div>
</template>


// WEBPACK FOOTER //
// src/components/forms/TimetableForm.vue